import { Link } from "react-router-dom";
import PageHead from "@/app/PageHead";
import { ProcessBrowser } from "@/features/process-browser/ProcessBrowserPage";

interface Props {
  marketing?: boolean;
}

export default function HomePage({ marketing = false }: Props) {
  if (marketing) {
    return (
      <section className="max-w-3xl">
        <PageHead
          title="About"
          description="What the Cowork Cookbook is and how to use it."
        />
        <h1 className="text-3xl font-bold tracking-tight">About the Cowork Cookbook</h1>
        <p className="mt-3 text-slate-700 dark:text-slate-300">
          A community catalog of prompt and skill recipes for{" "}
          <a
            href="https://learn.microsoft.com/en-us/microsoft-365/copilot/cowork/"
            target="_blank"
            rel="noreferrer"
            className="text-brand-600 dark:text-brand-500 underline"
          >
            Microsoft Copilot Cowork
          </a>
          , organized along Microsoft&apos;s{" "}
          <a
            href="https://learn.microsoft.com/en-us/dynamics365/guidance/business-processes/overview"
            target="_blank"
            rel="noreferrer"
            className="text-brand-600 dark:text-brand-500 underline"
          >
            Business Process Catalog
          </a>
          .
        </p>
        <p className="mt-3 text-slate-700 dark:text-slate-300">
          The initial focus is Dynamics 365 Finance &amp; Supply Chain Management — reporting,
          validation, period-close, master-data hygiene, and more.
        </p>
        <p className="mt-4 text-sm">
          <Link to="/" className="text-brand-600 dark:text-brand-500 hover:underline">
            Browse the catalog →
          </Link>
        </p>
      </section>
    );
  }
  return <ProcessBrowser current={null} />;
}
